import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, unref as _unref, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "tc-settings-container" }
const _hoisted_6 = { class: "card tc-card mb-4" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = { class: "form-group col-md-12" }
const _hoisted_10 = { class: "form-group col-md-6" }
const _hoisted_11 = { class: "form-group col-md-6" }
const _hoisted_12 = { class: "form-group col-md-6" }
const _hoisted_13 = { class: "form-group col-md-6" }

import { computed, shallowReactive, onMounted, watch, ref, type Ref } from 'vue'
    import { useRoute } from 'vue-router'
    import { generateName } from '@common/Common'
    import { guid } from '@common/Guid'
    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import Navigation from '@common/Navigation.vue'
    import ProjectNavigation from '@Quest/ProjectPlans/Components/ProjectNavigation.vue'
    import ProjectContextHeader from '@Quest/ProjectPlans/Components/ProjectContextHeader.vue'
    import { useProjectPlanSettingsPageQueryV1 } from '@Quest/ProjectPlans/queries-vue-composables'
    import { useUpdateProjectPlanCommandV1 } from '@Quest/ProjectPlans/commands-vue-composables'
    import type { ProjectPlanSettingsPageReadModel } from '@Quest/ProjectPlans/readmodels'
    import { CurrencyDenomination } from '../../../_Common/types'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectPlanSettingsPage',
  setup(__props) {

    const route = useRoute()
    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))
    const projectId = computed(() => String(route.params.projectId ?? ''))
    
    const rm = ref<ProjectPlanSettingsPageReadModel | null>(null);
    const projectPlanId = computed<string | null>(() => rm.value?.ProjectPlanId ?? null)
    const projectName = computed(() => rm.value?.ProjectName ?? '')
    const projectPlanName = computed<string>(() => rm.value?.ProjectPlanName ?? '')
    const activePlanId = computed<string | null>(() => rm.value?.ActiveProjectPlanId ?? null)

    const portfolioId = computed(() => rm.value?.PortfolioId ?? '')
    const userId = computed(() => rm.value?.UserId)
    const isWorkspaceMember = computed(() => rm.value?.IsWorkspaceMember ?? false)
    const isProjectOwner = computed(() => rm.value?.IsProjectOwner ?? false)

    const name = ref<string>('')
    const granularity = ref<string | null>(null)
    const denomination = ref<CurrencyDenomination>(CurrencyDenomination.Million)
    const durationInMonths = ref<number>(72)
    const submissionDueDate = ref<string | null>(null)

    const {
        runProjectPlanSettingsPageQueryV1,
        modelProjectPlanSettingsPageQueryV1
    } = useProjectPlanSettingsPageQueryV1(workspaceId, tchProjectId, projectId, projectPlanId)

    const {
        invokeUpdateProjectPlanCommandV1,
        onSucceedUpdateProjectPlanCommandV1
    } = useUpdateProjectPlanCommandV1(userId, workspaceId, portfolioId, projectId, projectPlanId, name, durationInMonths, granularity, denomination, submissionDueDate)

    onMounted(() =>
    {
        document.title = 'Project | TransparentChoice'

        runProjectPlanSettingsPageQueryV1({
            ProjectPlanId: route.params.planId ? String(route.params.planId) : null,
        })
    })

    watch(() => route.params.planId, () => 
    {
        runProjectPlanSettingsPageQueryV1({
            ProjectPlanId: route.params.planId as string | null
        })
    })

    watch(modelProjectPlanSettingsPageQueryV1, (current) =>
    {
        if (current?.RedirectUrl)
        {
            window.location.replace(current.RedirectUrl)
        }

        if (current)
        {
            rm.value = current
            name.value = rm.value.ProjectPlanName
            granularity.value = rm.value.Granularity
            denomination.value = rm.value.Denomination
            durationInMonths.value = rm.value.DurationInMonths
            submissionDueDate.value = rm.value.SubmissionDueDate
        }
    })

    onSucceedUpdateProjectPlanCommandV1(() =>
    {
        alert('done')
        runProjectPlanSettingsPageQueryV1()
    })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isWorkspaceMember.value)
      ? (_openBlock(), _createBlock(PortfolioNavigation, {
          key: 0,
          workspaceId: workspaceId.value,
          projectId: tchProjectId.value
        }, null, 8 /* PROPS */, ["workspaceId", "projectId"]))
      : (isProjectOwner.value)
        ? (_openBlock(), _createBlock(Navigation, { key: 1 }))
        : _createCommentVNode("v-if", true),
    (rm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(ProjectContextHeader, {
                projectName: projectName.value,
                planId: projectPlanId.value,
                planName: projectPlanName.value,
                activePlanId: activePlanId.value
              }, null, 8 /* PROPS */, ["projectName", "planId", "planName", "activePlanId"])
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-lg-6 text-right align-self-end" }, null, -1 /* CACHED */))
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          (rm.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(ProjectNavigation, {
                  ActivePage: "settings",
                  class: "mt-4 mb-4",
                  workspaceId: workspaceId.value,
                  tchProjectId: tchProjectId.value,
                  projectId: projectId.value,
                  planId: projectPlanId.value
                }, null, 8 /* PROPS */, ["workspaceId", "tchProjectId", "projectId", "planId"]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("form", {
                    id: "project-plan-editor-form",
                    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_unref(invokeUpdateProjectPlanCommandV1) && _unref(invokeUpdateProjectPlanCommandV1)(...args)), ["prevent"]))
                  }, [
                    _createCommentVNode(" ===== Plan settings ===== "),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[14] || (_cache[14] = _createElementVNode("h5", { class: "tc-section-title" }, "Settings", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _cache[7] || (_cache[7] = _createElementVNode("label", null, "Name", -1 /* CACHED */)),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                              class: "form-control",
                              required: "",
                              minlength: "2",
                              maxlength: "100"
                            }, null, 512 /* NEED_PATCH */), [
                              [
                                _vModelText,
                                name.value,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _cache[9] || (_cache[9] = _createElementVNode("label", null, "Granularity", -1 /* CACHED */)),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((granularity).value = $event)),
                              class: "form-control"
                            }, [...(_cache[8] || (_cache[8] = [
                              _createElementVNode("option", { value: "Monthly" }, "Monthly", -1 /* CACHED */),
                              _createElementVNode("option", { value: "Quarterly" }, "Quarterly", -1 /* CACHED */),
                              _createElementVNode("option", { value: "Yearly" }, "Yearly", -1 /* CACHED */)
                            ]))], 512 /* NEED_PATCH */), [
                              [_vModelSelect, granularity.value]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _cache[11] || (_cache[11] = _createElementVNode("label", null, "Currency denomination", -1 /* CACHED */)),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((denomination).value = $event)),
                              class: "form-control"
                            }, [...(_cache[10] || (_cache[10] = [
                              _createElementVNode("option", { value: "Unit" }, "Unit", -1 /* CACHED */),
                              _createElementVNode("option", { value: "Thousand" }, "Thousand", -1 /* CACHED */),
                              _createElementVNode("option", { value: "Million" }, "Million", -1 /* CACHED */)
                            ]))], 512 /* NEED_PATCH */), [
                              [_vModelSelect, denomination.value]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _cache[12] || (_cache[12] = _createElementVNode("label", null, "Duration (in months)", -1 /* CACHED */)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((durationInMonths).value = $event)),
                              class: "form-control",
                              required: "",
                              min: "1",
                              step: "1"
                            }, null, 512 /* NEED_PATCH */), [
                              [
                                _vModelText,
                                durationInMonths.value,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _cache[13] || (_cache[13] = _createElementVNode("label", null, "Submission due date", -1 /* CACHED */)),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((submissionDueDate).value = $event))
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, submissionDueDate.value]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ], 32 /* NEED_HYDRATION */),
                  _createCommentVNode(" ===== Actions ===== "),
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "tc-actions" }, [
                    _createElementVNode("button", {
                      type: "submit",
                      form: "project-plan-editor-form",
                      class: "btn btn-primary tc-save-btn"
                    }, " Save changes ")
                  ], -1 /* CACHED */))
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})